<a
  [class.pr-pill]="tab.notificationsCount"
  [routerLink]="tab.url"
  [class.current]="current"
  >{{ tab.label }}
  @if (tab.notificationsCount) {
    <div class="pill">
      @if (withPlus) {
        <span>+</span>{{ tab.notificationsCount }}
      } @else {
        {{ tab.notificationsCount }}
      }
    </div>
  }
</a>
